var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMLine1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 113,
    viewBox: "0 0 61 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1C9.88657 8.9538 12.7464 21.3416 16.1059 32.9429C22.9212 56.4781 22.1288 74.6862 34.3049 96.3191C38.5393 103.186 40.7623 106.447 45 113",
    stroke: "#F5EAD2",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M60 113C54.5668 105.304 49.8067 98.496 44.095 91.003C37.6037 82.4874 32.4684 73.0605 25.0752 65.1303C17.6821 57.2 0 50 0 50",
    stroke: "#C9C1AE",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMLine1);
export default __webpack_public_path__ + "static/media/mLine1.c0f2e8f78d4cf4077cb791b244c3e295.svg";
export { ForwardRef as ReactComponent };